import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d69dc5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "note-cell" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "note-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-file-export fas" }, null, -1))
const _hoisted_5 = { class: "dialog-footer" }

import { Pagination } from "@/types/pagination.type";
import { SamplingPointImageStatus } from "@/types/issueMonitoring.type.ts";
import { putSamplingPointsImageStatus } from "@/service/samplingPointImageStatus.service.ts";
import { computed, ref, onMounted } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
    pagination: null
  },
  setup(__props: any) {

const props = __props as {
  pagination: Pagination<SamplingPointImageStatus> | null;
}

const router = useRouter();

const dialogVisible = ref(false);

const note = ref("");
const entity = ref<SamplingPointImageStatus>({});



const points = computed(() => props.pagination || []);

const openDialog = (entityRow: SamplingPointImageStatus) => {
  dialogVisible.value = true;
  entity.value = entityRow;
  note.value = entityRow.note || "";
};

const saveDialog = async () => {
  const index = points.value.findIndex((i) => i.id === entity.value.id);

  if (index !== undefined) {
    points.value[index].note = note.value;
    await putSamplingPointsImageStatus(points.value[index]);
  }

  dialogVisible.value = false;
};

const goToSeeMore = (entity: SamplingPointImageStatus) => {
  router.push({
    path: `/issue-monitoring/list`,
    query: {
      point: entity.samplingPoint?.id,
    },
  });
};

const showColor = (entityRow: SamplingPointImageStatus) => {
  let type = "success";
  // HOY a las 08:30
  const today830 = new Date();
  today830.setHours(8, 30, 0, 0);

  // AYER a las 08:30
  const yesterday830 = new Date(today830);
  yesterday830.setDate(today830.getDate() - 1);

  const fromDateTime = entityRow?.lastIssue?.fromDateTime
    ? new Date(entityRow.lastIssue.fromDateTime)
    : null;

  if (entityRow.status === "ERROR") {
    type = "danger";
  } else if (
    entityRow.status === "OK" &&
    entityRow?.lastIssue &&
    entityRow?.lastIssue.fromDateTime &&
    fromDateTime >= yesterday830
  ) {
    type = "warning";
  }

  return type;
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_table, {
      data: _unref(points),
      style: {"width":"100%"},
      height: "calc(100vh - 200px)"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "samplingPoint.name",
          label: _ctx.$t('label.name'),
          width: "250"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "camera",
          label: _ctx.$t('label.camera'),
          width: "80"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: _ctx.$t('label.status'),
          width: "80",
          center: ""
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: showColor(scope.row),
              size: "small",
              round: ""
            }, null, 8, ["type"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "lastIssue.fromDateTime",
          label: _ctx.$t('label.startDate'),
          width: "140"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.lastIssue?.fromDateTime
              ? _ctx.$d(
                  new Date(scope.row.lastIssue?.fromDateTime.toLocaleString()),
                  "dateTimeNoSecs"
                ).replace(",", "")
              : "-"), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('label.issueDescription'),
          width: "400"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.lastIssue?.type?.name ? scope.row.lastIssue?.type?.name : "-") + " " + _toDisplayString(scope.row.lastIssue?.subtype?.name), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "note",
          label: _ctx.$t('label.note')
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("em", {
                class: "el-icon el-icon-edit fas",
                onClick: ($event: any) => (openDialog(scope.row))
              }, null, 8, _hoisted_2),
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: scope.row.note,
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.note), 1)
                ]),
                _: 2
              }, 1032, ["content"])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('label.operations')
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: _ctx.$t('menu.issueList'),
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (goToSeeMore(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1032, ["content"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: "Tips",
      width: "50%",
      "before-close": _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (saveDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: note.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((note).value = $event)),
          type: "textarea"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}
}

})